import React, { useState, useEffect } from 'react';
import axios from 'axios';
import qs from 'qs';
import { rescueHtml, addSpace } from '../Components/Tools.js';
import Logo from '../Img/Logo_projets&finances.png';

const Page6IncidencesFinancieres_Operations_Part2 = (props) => {
    const blue = '#069BD3';
    const green = '#59B44A';
    const red = '#E74C3C';
    const greyChapter = '#DBDBDB';
    const greyclair = '#FAFAFA';
    const fontsize = (props.height*12/890);
    
    const [operation, setOperation] = useState(props.operation);
    const [modalites, setModalites] = useState([]);

    useEffect(() => {
        if (props.operation && props.operation.id) {
            console.log(props.operation)
            setOperation(props.operation);
            loadIncidencesFinancieres(props.operation.id);
            loadModalites();
        }
    }, [props.operation?.id]);

    // Mettre à jour automatiquement le taux frais quand la modalité de portage change
    useEffect(() => {
        if (operation && operation.id_modalite_portage && modalites.length > 0) {
            const selectedModalite = modalites.find(m => String(m.id) === String(operation.id_modalite_portage));
            
            if (selectedModalite) {
                setOperation(prevOp => ({...prevOp, taux_frais_gestion: selectedModalite.taux}));
            }
        }
    }, [operation?.id_modalite_portage, modalites]);

    async function loadModalites() {
        try {
            const response = await axios.post('/api/modalites_portage.php', qs.stringify({
                get: true
            }));
            
            if (response && response.data) {
                const list = Array.isArray(response.data) ? response.data : (response.data.data ? response.data.data : []);
                setModalites(list || []);
            }
        } catch (err) {
            console.warn('Erreur lors du chargement des modalités:', err);
            setModalites([]);
        }
    }

    async function loadIncidencesFinancieres(operationId) {
        try {
            const response = await axios.post('/api/incidences_financieres_operations.php', qs.stringify({
                action: 'get_by_operation',
                id_operation: operationId
            }));
            
            if (response && response.data && response.data.status === 1 && response.data.data) {
                const incidencesData = response.data.data;
                
                setOperation(prevOp => {
                    if (!prevOp) return prevOp;
                    
                    const updated = {...prevOp};
                    
                    let maxYearIdx = -1;
                    
                    // Merger les données de la BDD dans l'objet operation
                    incidencesData.forEach(row => {
                        const yearIdx = parseInt(row.year_index) || 0;
                        maxYearIdx = Math.max(maxYearIdx, yearIdx);
                        
                        // Mapper tous les champs incidences_*
                        updated[`prix_acquisition_${yearIdx}`] = row.prix_acquisition || '';
                        updated[`frais_actes_${yearIdx}`] = row.frais_actes || '';
                        updated[`subventions_${yearIdx}`] = row.subventions || '';
                        updated[`retrocessions_${yearIdx}`] = row.retrocessions || '';
                        updated[`frais_prealables_${yearIdx}`] = row.frais_prealables || '';
                        updated[`frais_annexes_${yearIdx}`] = row.frais_annexes || '';
                        updated[`frais_gegr_${yearIdx}`] = row.frais_gegr || '';
                        updated[`frais_proto_amenagement_${yearIdx}`] = row.frais_proto_amenagement || '';
                        updated[`incidences_annuites_capital_porte_reel_${yearIdx}`] = row.incidences_annuites_capital_porte_reel || '';
                        updated[`incidences_annuites_hors_capital_porte_reel_${yearIdx}`] = row.incidences_annuites_hors_capital_porte_reel || '';
                        updated[`taux_applicable_capital_${yearIdx}`] = row.taux_applicable_capital || '';
                        updated[`entretien_reparations_${yearIdx}`] = row.entretien_reparations || '';
                        updated[`eau_electricite_${yearIdx}`] = row.eau_electricite || '';
                        updated[`charges_copropriete_${yearIdx}`] = row.charges_copropriete || '';
                        updated[`taxes_foncieres_${yearIdx}`] = row.taxes_foncieres || '';
                        updated[`taxe_redevance_om_${yearIdx}`] = row.taxe_redevance_om || '';
                        updated[`assurances_${yearIdx}`] = row.assurances || '';
                        updated[`autres_depenses_${yearIdx}`] = row.autres_depenses || '';
                        updated[`loyers_percus_${yearIdx}`] = row.loyers_percus || '';
                        updated[`refacturation_eau_electricite_${yearIdx}`] = row.refacturation_eau_electricite || '';
                        updated[`refacturation_charges_copropriete_${yearIdx}`] = row.refacturation_charges_copropriete || '';
                        updated[`refacturation_taxes_foncieres_${yearIdx}`] = row.refacturation_taxes_foncieres || '';
                        updated[`refacturation_om_${yearIdx}`] = row.refacturation_om || '';
                        updated[`refacturation_assurances_${yearIdx}`] = row.refacturation_assurances || '';
                        updated[`autres_recettes_${yearIdx}`] = row.autres_recettes || '';
                        updated[`total_annuel_capital_porte_${yearIdx}`] = row.total_annuel_capital_porte || '';
                        updated[`total_annuel_hors_capital_porte_${yearIdx}`] = row.total_annuel_hors_capital_porte || '';
                        updated[`incidences_annuites_capital_porte_${yearIdx}`] = row.incidences_annuites_capital_porte || '';
                        updated[`annuite_hors_capital_porte_${yearIdx}`] = row.annuite_hors_capital_porte || '';
                        updated[`annuite_definitive_${yearIdx}`] = row.annuite_definitive || '';
                        updated[`total_capital_stocke_${yearIdx}`] = row.total_capital_stocke || '';
                        updated[`total_capital_porte_${yearIdx}`] = row.total_capital_porte || '';
                        updated[`frais_portage_ht_${yearIdx}`] = row.frais_portage_ht || '';
                        updated[`tva_frais_portage_${yearIdx}`] = row.tva_frais_portage || '';
                        updated[`frais_portage_ttc_${yearIdx}`] = row.frais_portage_ttc || '';
                        updated[`total_depenses_${yearIdx}`] = row.total_depenses || '';
                        updated[`total_recettes_${yearIdx}`] = row.total_recettes || '';
                        updated[`solde_annuel_frais_gestion_${yearIdx}`] = row.solde_annuel_frais_gestion || '';
                        updated[`solde_cumule_frais_gestion_${yearIdx}`] = row.solde_cumule_frais_gestion || '';
                        updated[`solde_operation_${yearIdx}`] = row.solde_operation || '';
                    });
                    
                    // Récupérer le solde d'opération de la dernière année
                    if (maxYearIdx >= 0) {
                        updated.solde_operation = updated[`solde_operation_${maxYearIdx}`] || '';
                    }
                    
                    return updated;
                });
            }
        } catch (err) {
            console.warn('Erreur lors du chargement des incidences financières:', err);
        }
    }

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'white'}}>
            
            {/* Header */}
            <div style={{ display: 'flex', height: '10%' }}>
                <div style={{ flex: 0.6, display: 'flex', marginLeft: 10 }}>
                    {props.logo && (
                        <img style={{ maxHeight: props.height / 8, borderRadius: 5 }} src={props.logo} alt="Logo" />
                    )}
                </div>

                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: blue, fontSize: (fontsize + 10) }}>Incidences Financières - Partie 2</p>
                </div>

                <div style={{ flex: 0.6, display: 'flex', justifyContent: 'right', marginRight: 25 }}>
                    <p style={{ color: 'grey', fontSize: (fontsize + 4) }}>{operation?.nom}</p>
                </div>
            </div>

            {/* Contenu - 60% */}
            <div style={{flex: 1, padding: '0 15px', overflow: 'hidden', minHeight: 0, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                
                {/* Récapitulatif des données - Style OperationPage */}
                <div style={{display: 'flex', gap: 12, marginBottom: 12, padding: '8px 0', borderBottom: `1px solid ${greyclair}`, flexWrap: 'wrap'}}>
                    <div style={{flex: 1}}></div>
                    {/* <div style={{display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center'}}>
                        <p style={{margin: 0, fontSize: fontsize, color: '#999'}}>Année de 1ère acquisition</p>
                        <p style={{margin: 0, fontSize: fontsize+3, fontWeight: 'bold', color: blue}}>
                            {operation?.date_premiere_acquisition ? new Date(operation.date_premiere_acquisition).getFullYear() : '-'}
                        </p>
                    </div> */}

                    <div style={{display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center'}}>
                        <p style={{margin: 0, fontSize: fontsize, color: '#999'}}>Année de 1ère facturation</p>
                        <p style={{margin: 0, fontSize: fontsize+3, fontWeight: 'bold', color: blue}}>
                            {operation?.date_premiere_facturation ? new Date(operation.date_premiere_facturation).getFullYear() : '-'}
                        </p>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center'}}>
                        <p style={{margin: 0, fontSize: fontsize, color: '#999'}}>Durée portage</p>
                        <p style={{margin: 0, fontSize: fontsize+3, fontWeight: 'bold', color: blue}}>
                            {operation?.duree_portage || '-'} ans
                        </p>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center'}}>
                        <p style={{margin: 0, fontSize: fontsize, color: '#999'}}>Durée différé</p>
                        <p style={{margin: 0, fontSize: fontsize+3, fontWeight: 'bold', color: blue}}>
                            {operation?.duree_differe || '-'} ans
                        </p>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center'}}>
                        <p style={{margin: 0, fontSize: fontsize, color: '#999'}}>Taux frais</p>
                        <p style={{margin: 0, fontSize: fontsize+3, fontWeight: 'bold', color: blue}}>
                            {operation?.taux_frais_gestion || '-'}%
                        </p>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center'}}>
                        <p style={{margin: 0, fontSize: fontsize, color: '#999'}}>Solde d'opération</p>
                        <p style={{margin: 0, fontSize: fontsize+3, fontWeight: 'bold', color: blue}}>
                            {operation?.solde_operation 
                                ? parseFloat(operation.solde_operation).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
                                : '-'
                            }
                        </p>
                    </div>
                    <div style={{flex: 1}}></div>
                </div>

                {/* Tableau complet - comme dans OperationPage */}
                {operation && operation.duree_portage && parseInt(operation.duree_portage) > 0 ? (
                    <div style={{width: '100%', overflowX: 'hidden', overflowY: 'hidden', flex: 1, borderRadius: '6px', border: `1px solid ${greyclair}`, marginTop: '8px', position: 'relative', minWidth: 0}}>
                        <div style={{display: 'flex', minWidth: 'min-content', height: '100%'}}>
                            {/* Colonne Catégorie */}
                            <div style={{width: 40, minWidth: 40, backgroundColor: 'transparent', display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden', flexShrink: 0}}>
                                {/* Header */}
                                <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent', fontWeight: 'bold', position: 'sticky', left: 0, top: 0, zIndex: 12}}></div>
                                
                                {/* Dépenses */}
                                <div style={{flex:8, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRight: '1px solid #ccc', borderTopLeftRadius: 5, borderBottomLeftRadius: 5}}>
                                    <div style={{transform: 'rotate(-90deg)', transformOrigin: 'center', whiteSpace: 'nowrap', fontSize: 12, fontWeight: 'bold', color: '#666'}}>Dépenses</div>
                                </div>

                                <div style={{flex:0.5, display: 'flex'}}></div>
                                
                                {/* Recettes */}
                                <div style={{flex: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRight: '1px solid #ccc', borderTopLeftRadius: 5, borderBottomLeftRadius: 5}}>
                                    <div style={{transform: 'rotate(-90deg)', transformOrigin: 'center', whiteSpace: 'nowrap', fontSize: 12, fontWeight: 'bold', color: '#666'}}>Recettes</div>
                                </div>
                                <div style={{flex:3.5, display: 'flex'}}></div>
                            </div>

                            {/* Colonne Figée - Libellés */}
                            <div style={{minWidth: 200, maxWidth: 300, backgroundColor: 'transparent', flexShrink: 0, display: 'flex', flexDirection: 'column'}}>
                                {/* Header */}
                                <div style={{display: 'flex', flex: 1, alignItems: 'center', padding: '0 10px', backgroundColor: blue, fontWeight: 'bold', position: 'sticky', left: 0, top: 0, zIndex: 12}}>
                                    <p style={{marginTop: (0-props.marge), color: 'white', margin: 0, fontSize: fontsize-1}}>Libellé (en euro)</p>
                                </div>

                                {/* Lignes */}
                                {[
                                    { label: 'Entretien réparations [ER]', key: 'entretien_reparations', compte: '615' },
                                    { label: 'Eau/électricité [DEE]', key: 'eau_electricite', compte: '6061' },
                                    { label: 'Charges de copro. [DCC]', key: 'charges_copropriete', compte: '614' },
                                    { label: 'Taxes foncières [DTFB]', key: 'taxes_foncieres', compte: '6351' },
                                    { label: 'Taxe/redevance OM [DOM]', key: 'taxe_redevance_om', compte: '6351' },
                                    { label: 'Assurances [DASS]', key: 'assurances', compte: '616' },
                                    { label: 'Autres [DAU]', key: 'autres_depenses', compte: '618' },
                                    { label: 'TOTAL Dépenses [TOTDEP]', key: 'total_depenses', isBold: true, isCalculated: true },
                                    { label: '', isEmpty: true },
                                    { label: 'Loyers perçus [LOY]', key: 'loyers_percus', compte: '7083' },
                                    { label: 'Refacturation - Eau/électricité [REE]', key: 'refacturation_eau_electricite', compte: '7087' },
                                    { label: 'Refacturation - Charges de copro. [RCC]', key: 'refacturation_charges_copropriete', compte: '7087' },
                                    { label: 'Refacturation - Taxes foncières [RTFB]', key: 'refacturation_taxes_foncieres', compte: '7087' },
                                    { label: 'Refacturation - OM [ROM]', key: 'refacturation_om', compte: '7087' },
                                    { label: 'Refacturation - Assurances [RASS]', key: 'refacturation_assurances', compte: '7087' },
                                    { label: 'Autres [RAU]', key: 'autres_recettes', compte: '7088' },
                                    { label: 'TOTAL Recettes [TOTREC]', key: 'total_recettes', isBold: true, isCalculated: true },
                                    { label: '', isEmpty: true },
                                    { label: 'Solde annuel frais de gestion [SAFG]', key: 'solde_annuel_frais_gestion', isBold: true, isCalculated: true },
                                    { label: 'Solde cumulé frais de gestion [SCFG]', key: 'solde_cumule_frais_gestion', isBold: true, isCalculated: true },
                                    { label: 'Solde d\'opération fin d\'année [SO]', key: 'solde_operation', isBold: true, isCalculated: true }
                                ].map((row, idx) => (
                                    <div key={idx} style={{display: 'flex', flex: row.isEmpty ? 0.5 : 1, alignItems: 'center', padding: '0 8px', borderBottom: '1px solid #ddd', backgroundColor: row.isCalculated ? '#f0f0f0' : '#ffffff', position: 'sticky', left: 0, zIndex: 11}}>
                                        <p style={{marginTop: (0-props.marge), fontSize: fontsize, fontWeight: row.isBold ? 'bold' : 'normal', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                            {row.compte && (
                                                <>
                                                    <span style={{color: 'red'}}>{row.compte}</span>
                                                    {' - '}
                                                </>
                                            )}
                                            {row.label}
                                        </p>
                                    </div>
                                ))}
                            </div>

                            {/* Colonnes de données */}
                            <div style={{display: 'flex', flex: 1}}>
                                {(() => {
                                    const currentYear = new Date().getFullYear();
                                    let endYear = currentYear;
                                    
                                    if (operation?.date_premiere_acquisition && operation?.duree_portage) {
                                        const yearAcquisition = new Date(operation.date_premiere_acquisition).getFullYear();
                                        endYear = yearAcquisition + parseInt(operation.duree_portage);
                                    }
                                    
                                    const totalColumnsAll = Math.max(0, endYear - currentYear + 1);
                                    const totalColumns = Math.min(9, totalColumnsAll); // Maximum 9 colonnes
                                    
                                    return Array.from({length: totalColumns}).map((_, yearIdx) => (
                                        <div key={yearIdx} style={{flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0}}>
                                            {/* Header année */}
                                            <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', padding: '0 3px', backgroundColor: blue, fontWeight: 'bold', borderBottom: '1px solid #ddd', position: 'sticky', top: 0, zIndex: 10}}>
                                                <p style={{marginTop: (0-props.marge), color: 'white', fontSize: fontsize-2}}>
                                                    {currentYear + yearIdx}
                                                </p>
                                            </div>

                                            {/* Données */}
                                            {[
                                                { key: 'entretien_reparations', isCalculated: false },
                                                { key: 'eau_electricite', isCalculated: false },
                                                { key: 'charges_copropriete', isCalculated: false },
                                                { key: 'taxes_foncieres', isCalculated: false },
                                                { key: 'taxe_redevance_om', isCalculated: false },
                                                { key: 'assurances', isCalculated: false },
                                                { key: 'autres_depenses', isCalculated: false },
                                                { key: 'total_depenses', isBold: true, isCalculated: true },
                                                { isEmpty: true },
                                                { key: 'loyers_percus', isCalculated: false },
                                                { key: 'refacturation_eau_electricite', isCalculated: false },
                                                { key: 'refacturation_charges_copropriete', isCalculated: false },
                                                { key: 'refacturation_taxes_foncieres', isCalculated: false },
                                                { key: 'refacturation_om', isCalculated: false },
                                                { key: 'refacturation_assurances', isCalculated: false },
                                                { key: 'autres_recettes', isCalculated: false },
                                                { key: 'total_recettes', isBold: true, isCalculated: true },
                                                { isEmpty: true },
                                                { key: 'solde_annuel_frais_gestion', isBold: true, isCalculated: true },
                                                { key: 'solde_cumule_frais_gestion', isBold: true, isCalculated: true },
                                                { key: 'solde_operation', isBold: true, isCalculated: true }
                                            ].map((row, idx) => {
                                                const columnYear = currentYear + yearIdx;
                                                let yearIdxForData = 0;
                                                
                                                if (operation?.date_premiere_acquisition) {
                                                    const yearAcquisition = new Date(operation.date_premiere_acquisition).getFullYear();
                                                    yearIdxForData = columnYear - yearAcquisition;
                                                }
                                                
                                                const fieldName = row.key ? `${row.key}_${yearIdxForData}` : null;
                                                const displayValue = fieldName ? operation?.[fieldName] : null;
                                                
                                                const formatNumber = (num) => {
                                                    if (!num || isNaN(num)) return '';
                                                    const parsed = parseFloat(num);
                                                    return parsed.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                                };

                                                const isZeroOrEmpty = (val) => {
                                                    if (!val || val === '') return true;
                                                    const parsed = parseFloat(String(val).replace(',', '.'));
                                                    return isNaN(parsed) || parsed === 0;
                                                };
                                                
                                                return (
                                                    <div key={idx} style={{display: 'flex', flex: row.isEmpty ? 0.5 : 1, borderBottom: '1px solid #ddd', alignItems: 'center', justifyContent: 'center', backgroundColor: row.isEmpty ? 'transparent' : '#ffffff'}}>
                                                        {row.isEmpty ? (
                                                            <div></div>
                                                        ) : isZeroOrEmpty(displayValue) ? (
                                                            <div style={{width: '100%', height: '100%', fontSize: fontsize-1, textAlign: 'center', fontWeight: row.isBold ? 700 : 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: row.isCalculated ? '#f0f0f0' : '#ffffff', borderLeft: '1px solid #ddd', color: row.isBold ? '#000' : '#666', padding: '0 2px'}}>
                                                                &nbsp;
                                                            </div>
                                                        ) : (
                                                            <div style={{width: '100%', height: '100%', fontSize: fontsize-1, textAlign: 'center', fontWeight: row.isBold ? 700 : 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: row.isCalculated ? '#f0f0f0' : '#ffffff', borderLeft: '1px solid #ddd', color: row.isBold ? '#000' : '#666', padding: '0 2px'}}>
                                                                {formatNumber(displayValue)}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ));
                                })()}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div style={{
                        backgroundColor: greyclair,
                        padding: '20px',
                        borderRadius: '6px',
                        textAlign: 'center',
                        border: `1px solid ${blue}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flex: 1
                    }}>
                        <p style={{fontSize: fontsize-1, color: greyChapter, margin: 0}}>
                            Aucune incidence enregistrée
                        </p>
                    </div>
                )}
            </div>

            {/* Footer - 20% */}
            <div style={{padding: '5px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1, flexShrink: 0}}>
                <div>
                    <p style={{fontSize: fontsize, color: '#666'}}>
                        {props.date}
                    </p>
                </div>
                <p style={{fontSize: fontsize, color: '#8B8B8B'}}>page : {props.pagination} / {props.countPageTotal}</p>
                <div>
                    <img style={{objectFit: 'contain', height: 40, borderRadius: 6}} src={Logo} alt="Logo SF" />
                </div>
            </div>
        </div>
    );
};

export default Page6IncidencesFinancieres_Operations_Part2;
